import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import AddRetourExcluDialog from './AddRetourExcluDialog';

import DeleteRetourExcluDialog from './DeleteRetourExcluDialog';
import { green } from '@mui/material/colors';



const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },
    table: {
        //minWidth: 700
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },

    link: theme.style.link, 
       
    administrationHeaderContainer: {
        display: 'flex',
        width: '100%'
    },
    administrationHeaderItemLeft: {
        flex: '1 1 auto'
    },
    administrationHeaderItemRight: {
        flex: '0 1 auto'
    },

    deleting: {
        background : 'red'
    },


    nowrapCell: {
        whiteSpace: 'nowrap'
    }  

});



class AdministrationRetourExclus extends React.Component {
    
    render() {

        let {
            classes, retourExclus, niveaux,
            addRetourExcluDialogOpen, onOpenAddDialog, onCloseAddDialog, addRetourExclu,
            deleteRetourExcluDialogOpen, onOpenDeleteDialog, onCloseDeleteDialog, deleteRetourExclu, retourExcluToDelete
         } = this.props;

        return (
            <React.Fragment>

                {addRetourExcluDialogOpen && <AddRetourExcluDialog niveaux={niveaux} onClose={onCloseAddDialog} onClickSave={addRetourExclu} />}
                {deleteRetourExcluDialogOpen && <DeleteRetourExcluDialog niveaux={niveaux} onClose={onCloseDeleteDialog} onClickDelete={deleteRetourExclu} retourExclu={retourExcluToDelete} />}


                <div className={classes.administrationHeaderContainer}>
                    <Typography gutterBottom variant="h5" className={classes.administrationHeaderItemLeft}>
                        Administration des exclusions pour les retours
                    </Typography>
                    <Button className={classes.administrationHeaderItemRight} onClick={onOpenAddDialog}>Nouvelle</Button>
                </div>

                <Paper className={classes.root}>

                    <Table className={classes.table} size='small'>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell align='right'>Id</TableCell> */}
                                <TableCell>Niveau</TableCell>
                                <TableCell>Code</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {retourExclus.map(retourExclu => {
                                let niveau = niveaux.find(n => n.id === retourExclu.niveau);
                                return (
                                    <TableRow key={retourExclu.id} className={retourExcluToDelete && retourExcluToDelete.id === retourExclu.id ? classes.deleting :''}
                                        hover
                                    >
                                        {/* 
                                        <TableCell component="th" scope="row" align='right'>
                                            <Link to={`/administration/retourExclus/${retourExclu.id}`} className={classes.link}>
                                                <Typography variant="button">
                                                    {retourExclu.id}
                                                </Typography>
                                            </Link>
                                        </TableCell>
                                        */}
                                        
                                        <TableCell>{niveau.libelle}</TableCell>
                                        <TableCell>{retourExclu.code}</TableCell>
                                        <TableCell>
                                            <Button onClick={e => onOpenDeleteDialog(retourExclu.id)}>Supprimer</Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>

                </Paper>

            </React.Fragment>


        );
    }
}

AdministrationRetourExclus.propTypes = {
    classes: PropTypes.object.isRequired,
    niveaux: PropTypes.array.isRequired,
    retourExclus: PropTypes.array.isRequired
};

export default withStyles(styles)(AdministrationRetourExclus);